// Firestore

type TPlant = { categoryId: string; id: string }[];

export interface ICatalog {
  categories: { id: string; name: string; harvestingInstructions: string[] }[];
  plants: TPlant[];
  schemaVersion: string;
}

// Server
interface ApiPlantInventory {
  status: InventoryStatusType;
  /* eslint-disable camelcase */
  plant_id: string;
  /* eslint-enable camelcase */
}

export enum InventoryStatus {
  InStock = 'in_Stock',
  OutOfStock = 'out_of_stock',
  Disabled = 'disabled'
}

export type InventoryStatusType = `${InventoryStatus}`;

interface ApiPlantLifeCycle {
  /* eslint-disable camelcase */
  days_to_end_of_life: number;
  days_to_germination: number;
  days_to_harvest: number;
  /* eslint-enable camelcase */
}

export enum PlantTag {
  Big = 'BIG'
}

export type PlantTagType = `${PlantTag}`;

export interface ApiPlant {
  /* eslint-disable camelcase */
  inventory: ApiPlantInventory;
  plant: {
    category: string;
    id: string;
    image_id: string;
    life_cycle: ApiPlantLifeCycle;
    name: string;
    short_name: string;
    tags: PlantTagType[];
  }
  /* eslint-enable camelcase */
}

export interface ApiCategory {
  id: string;
  name: string;
}

export interface ApiPlantsCatalogs {
  plants: ApiPlant[];
  categories:ApiCategory[];
  imageBaseUrl: string;
}

export const deviceType = 'indoor_greenhouse';

// REST API
// TODO fill this out from readme.md
